import { Text } from "@/components/atoms/Text/Text";

interface Props {
  children: React.ReactNode;
}

export function TrialTitle({ children }: Props) {
  return (
    <Text variant="h5-semibold" as="h2" tone="emphasis" data-sentry-element="Text" data-sentry-component="TrialTitle" data-sentry-source-file="TrialTitle.tsx">
      {children}
    </Text>
  );
}
